import { useLayoutEffect, useEffect, useState, useRef, useMemo, createContext } from 'react'
// import * as am5 from "@amcharts/amcharts5"
// import * as am5xy from "@amcharts/amcharts5/xy"
// import * as am5radar from "@amcharts/amcharts5/radar"
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"

import { useSpring, animated } from "@react-spring/web";

// import ChartJS features
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale } from "chart.js";
// import the doughnut chart
import { Doughnut } from "react-chartjs-2";

// import Toast
import { ToastContainer, toast } from "react-toastify";
// import Toast's CSS styling
import "react-toastify/dist/ReactToastify.css";

// import React App's CSS styling
import './App.css';

// used within MapChart and GaugeChart JSX files
export let updateGaugeRangeAndValue;

var maxGaugeRange = 25; // default max range
var needleReachedNegative = false; // used to toggle hiding needle
var reachedUnknown = false; // used to toggle hiding needle

// used to color the text of EUI value and quality
var EUIColors = [
    "rgb(0, 255, 0)",
    "rgb(155, 255, 100)",
    "#f1ce62",
    "rgb(255, 155, 0)",
    "rgb(255, 0, 0)",
    "rgb(200, 0, 0)"
];


    
var isAnimating = false; // 🚀 Prevent multiple animations from overlapping

function GaugeChart({ isCooldown, setIsCooldown, toastShown2, setToastShown2, fiscalYear, previousFiscalYear}) {
    const gaugeRef = useRef(null);
    // cannot use useState in effect/callback functions
    
    const [buildingName, setBuildingName] = useState("Click on a Building to see its EUI Value");
    const [coolingLoop, setCoolingLoop] = useState("");
    const [quality, setQuality] = useState("Excellent EUI");
    const [gaugeValue, setGaugeValue] = useState(0);
    const [needleValue, setNeedleValue] = useState(0); // Initial needle position
    const [EUIMessage, setEUIMessage] = useState("");
    const [color, setColor] = useState("black");
    //const [isCooldown, setIsCoolDown] = useState(false);
    const [toastShown, setToastShown] = useState(false);
    const [labels, setLabels] = useState(["0", "5", "10", "15", "20", "25+"]);
    const [dataValues, setDataValues] = useState([5, 5, 5, 5, 5]);

    // data of the gauge chart
    const theData = ({
        labels: labels, // numeric labels
        datasets: [{
            data: dataValues, // Adjust values for each section
            backgroundColor: ["rgb(0, 255, 0)", "rgb(155, 255, 100)", "#FFFF00", "rgb(255, 155, 0)", "rgb(255, 0, 0)"],
            borderWidth: 0,
            needleValue: needleValue,
        }]
    });

    // useEffect(() => {
        
    //     if (!gaugeRef.current) return; // Ensure ref exists
        
    //     const chart = gaugeRef.current.chart;
    //     if (!chart?.data?.datasets?.length) return; // Prevent errors if datasets is undefined
    //     chart.data.datasets[0].data = dataValues;
    //     chart.data.labels = labels;
    //     chart.datasets[0].needleValue = needleValue;
    //     chart.update(); // Update chart instead of recreating
    // }, [dataValues, labels, needleValue]);

// used to display labels on the gauyge chart
var gaugeLabelsPlugin = {
        id: "gaugeLabels",
        afterDraw(chart, theLabels) {
            const { ctx, data, chartArea } = chart;
            if (!chartArea) return; // Ensure chart area exists (if it doesn't, prolly won't display anything)

            const { width, height } = chartArea;
            //ctx.clearRect(0, 0, width, height);
            
            const gaugeData = chart.getDatasetMeta(0).data[0]; 
            const centerX = gaugeData.x; // chart.getDatasetMeta(0).data[0].x width / 2
            const centerY = gaugeData.y; // chart.getDatasetMeta(0).data[0].y height / 2
            const radius = gaugeData.outerRadius; // Math.min(width, height) / 2.5

            theLabels = data.labels || theLabels; // use default data on start, update label data when gauge changes

            const labels = theLabels;
            const totalSections = labels.length;

            const startAngle = 150 * Math.PI / 180;
            const endAngle = 390 * Math.PI / 180;
            const step = (endAngle - startAngle) / (totalSections - 1);

            // 6 numeric labels in total, inside the forEach positions each numeric label
            labels.forEach((label, index) => {
                //const circumferencePosition = ((chart.getDatasetMeta(0).data[0].circumference / Math.PI) / data.datasets[0].data[0]) * label;
                
                const angle = startAngle + index * step; // (-240 + (index * (240 / (totalSections - 1)))) * (Math.PI / 240)

                const offsetX = width * 0.08;
                const offsetY = height * 0.33;

                let x = centerX + (radius * 1.05) * Math.cos(angle);
                let y = centerY + (radius * 1.15) * Math.sin(angle);
                
                ctx.textAlign = "center";

                // Shift specific numbers downward
                if ([theLabels[1]].includes(label)) {
                    //y += 70; // Adjust this value based on how much lower you want them
                    //x += 60;
                    ctx.textAlign = "right";
                }

                if ([theLabels[2]].includes(label)) {
                    //y -= 20; // Adjust this value based on how much lower you want them
                    //x += 20;

                }

                if ([theLabels[3]].includes(label)) {
                    //y -= 20; // Adjust this value based on how much lower you want them
                    //x -= 20;
                }

                // Shift specific numbers downward
                if ([theLabels[4]].includes(label)) {
                    //y += 70; // Adjust this value based on how much lower you want them
                    //x -= 60;
                    ctx.textAlign = "left";
                }

                // Shift specific numbers downward
                if ([theLabels[5]].includes(label)) {
                    //y += 180; // Adjust this value based on how much lower you want them
                    //x -= 120;
                    ctx.textAlign = "left";
                }

                // Shift specific numbers downward
                if ([theLabels[0]].includes(label)) {
                    //y += 180; // Adjust this value based on how much lower you want them
                    //x += 130;
                    ctx.textAlign = "right";
                }

                // if (angle < -240) {
                //     y += height * 0.1;
                // } else {
                //     y -= height * 0.01;
                // }

                // CSS-based styling that makes the text black and uses react-bootstrap styling 
                ctx.fillStyle = "#000";
                ctx.font = `${Math.min(width, height) / 15}px  'Segoe UI', sans-serif`; 
                
                ctx.textBaseline = "middle";

                // display each numeric label
                ctx.fillText(label, x, y);
                
            });
            //ctx.restore();
            // console.log("Drawing labels...", labels);
            
            // ???
            // window.addEventListener("resize", () => {
            //         chart.update(); // Forces chart to redraw with new dimensions
            // }); 
        }
    };
    // used to display the needle on the gauge chart
    var gaugeNeedlePlugin = {
        id: "gaugeNeedle",
        afterDatasetDraw(chart, args, options) {
          const { ctx, data, chartArea: { top, left, width, height } } = chart;
          gaugeRef.current = chart; // ✅ Store chart reference globally so it's accessible
          ctx.save();
          
          //
          const needleValue = data.datasets[0].needleValue; // Animated value
          // data.datasets[0].needleValue
          // 
          const dataTotal = data.datasets[0].data.reduce((a, b) => a + b, 0);
          // 
          // const angle = (4 * Math.PI) / 3;
      
          const cx = chart.getDatasetMeta(0).data[0].x; // left + width / 2
          const cy = chart.getDatasetMeta(0).data[0].y; // top + height - (height / 2.5)
          const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
          const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
          const sliceThickness = (outerRadius - innerRadius) / 2;
          const radius = 8;

          const circumferencePosition = ((chart.getDatasetMeta(0).data[0].circumference / Math.PI) / data.datasets[0].data[0]) * needleValue;
      
          ctx.translate(cx, cy);
          ctx.rotate(Math.PI * (circumferencePosition + (4/3)));
      
          ctx.beginPath(); 
          ctx.arc(0, 0, radius, 0, Math.PI * 2); // Adjust radius for round bottom
          ctx.moveTo(0 - radius, 0); // needle LHS lower half
          ctx.lineTo(0, 0 - innerRadius - sliceThickness); // adjust needle tip's thickness (smaller first param means needle is pointier) // innerRadius brings up to inner edge and sliceThickness brings up to in between the width of the slice
          ctx.lineTo(0 + radius, 0); // needle RHS lower half
          //if (needleValue === maxGaugeRange)   ctx.fillStyle = "rgb(200, 0, 0)";
          ctx.closePath();

          // use Biconditional operator on the negated booleans (hides the needle if the user clicks on a builing with an Unknown OR No EUI value)
          if (!needleReachedNegative && !reachedUnknown) ctx.fill();

          // 🚀 Force needle color persistence AFTER Chart.js redraws
            setTimeout(() => {
                ctx.fillStyle = (needleValue >= maxGaugeRange) ? "rgb(200, 0, 0)" : "black";
                //console.log("Enforcing needle color after Chart.js redraw");
            }, 0.1); // Small delay lets Chart.js finish updating first
        
        //   ctx.rotate(-angle);
        //   ctx.translate(-cx, -cy);
          ctx.restore();

          
        }
      };

    let animationFrameId; // Declare in a higher scope
    function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3); // Easing formula
    }
    
    // to animate color transition of a shape
    function interpolateColor(startColor, endColor, progress) {
        const r = Math.round(startColor[0] + (endColor[0] - startColor[0]) * progress);
        const g = Math.round(startColor[1] + (endColor[1] - startColor[1]) * progress);
        const b = Math.round(startColor[2] + (endColor[2] - startColor[2]) * progress);
        return `rgb(${r}, ${g}, ${b})`;
    }

    // used to animate needle when the gauge chart updates (default animation duration is 1.5 seconds)
    function animateNeedle(startValue, targetValue, duration = 1500) {

        if (!gaugeRef.current) return; // Ensure ref exists
    
        const ctx = gaugeRef.current.ctx; // ✅ Retrieve stored canvas context
        if (!ctx) return; // Prevent errors

        // 🚀 If an animation is running, prevent starting a new one
        if (isAnimating) return;  
        isAnimating = true; // ✅ Lock the animation process
        if (animationFrameId)   cancelAnimationFrame(animationFrameId); // Stop any previous animation
        
        animationFrameId = null; // Reset animation frame ID
        const startTime = performance.now();
        
        let startColor, endColor, blendedColor;

        function step(timestamp) {
            const progress = Math.min((timestamp - startTime) / duration, 1);
            //setAnimationTime(progress * duration);
            const easedProgress = easeOutCubic(progress);
      
            let currentValue = startValue + (targetValue - startValue) * easedProgress;

            // 🚀 Ensure needle does not exceed `maxGaugeRange`
            currentValue = Math.min(currentValue, maxGaugeRange);
    
            if (gaugeRef.current) {
                gaugeRef.current.data.datasets[0].needleValue = currentValue;
                gaugeRef.current.update(); // Ensure Chart.js refreshes
            }
            //console.log(currentValue);

            // used to hide/show needle (hide needle if below zero, show needle if at or above zero)
            needleReachedNegative = currentValue < 0;
            
            // 🚀 Trigger color transition ONLY when coming FROM deep red
            const needleWasRed = startValue >= maxGaugeRange;
            //console.log(startValue + " > " + maxGaugeRange);
            const needleWillBeRed = targetValue >= maxGaugeRange;
            //console.log(targetValue + " > " + maxGaugeRange);
            if (needleWasRed && !needleWillBeRed) {
                // ✅ Needle is transitioning FROM red TO black (fix colors)
                startColor = [200, 0, 0];  // Red
                endColor = [0, 0, 0];      // Black
                blendedColor = interpolateColor(startColor, endColor, easedProgress);
                ctx.fillStyle = blendedColor;
                console.log("Color transition: Red → Black");
            } else if (!needleWasRed && needleWillBeRed) {
                // ✅ Needle is transitioning FROM black TO red (fix colors)
                startColor = [0, 0, 0];    // Black
                endColor = [200, 0, 0];    // Red
                blendedColor = interpolateColor(startColor, endColor, easedProgress);
                ctx.fillStyle = blendedColor;
                console.log("Color transition: Black → Red");
                
            } else {
                // 🚀 No transition needed—stick to final state ( when clicking on the building with similar needle color)
                ctx.fillStyle = needleWillBeRed ? "rgb(200, 0, 0)" : "black";
            }

            if (progress < 1) {
                animationFrameId = requestAnimationFrame(step); // Assign the correct animation frame ID

            } else {
                setNeedleValue(targetValue > maxGaugeRange ? maxGaugeRange : targetValue);
                isAnimating = false;
            }
        }
        
        animationFrameId = requestAnimationFrame(step); // Start animation properly
        //console.log(ctx.fillStyle);
    }

    // becomes a function that updates the gauge chart and the building information selected
    updateGaugeRangeAndValue = function (newMaxRange, euiValue, complexName, quality, buildingType, buildingGroup) {

        if (previousFiscalYear === fiscalYear) {
            // if condition is only applicable for FY 2023
            if ((buildingGroup === "" || buildingGroup === "B") && (fiscalYear === 2023))  {
                // don't update gauge chart if the user clicks on the same building
                if (buildingName === complexName)   return;
                
            } else {
                console.log("im in");
                // used to prevent animating the needle since buildings in the same cooling loop share the same EUI value
                if (coolingLoop === buildingGroup)   {
                    
                    // update building name that's in the same cooling loop
                    setBuildingName(complexName);
                    return;
                }
            }
        } else {
            previousFiscalYear.current = fiscalYear;
        }
        
        // used to display toast
        if (isCooldown) {
            // display warning message if the user is on cooldown and toast isn't shown 
            if (!toastShown) {
                toast.warn(<>Please wait a little.</>, 
                { 
                    position: 'top-center',
                    autoClose: 1000, 
                    onClose: () => {
                        setToastShown(false);
                    }
                });
                // toast shown status is set to true, false 1 second after it shows up
                setToastShown(true);
            }
            return;
        }
        
        // if (previousBuildingName !== complexName) {
        //     setPreviousBuildingName(buildingName);
        // }
        
        // every time the user clicks on a building, activate cooldown and ensure the toast shown status is set to false
        setIsCooldown(true);
        setToastShown(false);
        
        let previousMaxRange = maxGaugeRange; // store previous max range for the needle to scale with different max ranges
        maxGaugeRange = (newMaxRange > 0) ? newMaxRange : 25; // used to prevent negative ranges
        
        let newLabels = [];
        let newDataValues = [];
        
        // what is b?
        let b = 0;

        let numSections = 6;
        for (let i = 0; i < numSections; i++) {
            newLabels[i] = (i != numSections - 1) ? (maxGaugeRange * b).toFixed(1) : (maxGaugeRange * b).toFixed(1) + "+";
                
            if (i < 5)   newDataValues[i] = (maxGaugeRange / 5).toFixed(1);
            // ?
            b += 0.2;
        }
        // update building's EUI quality
        setQuality(quality);

        let color = "";
        // setQuality(quality);
        switch (quality) {
            case "Excellent EUI":
                color = EUIColors[0];
                break;
            case "Good EUI":
                color = EUIColors[1];
                break;
            case "Average EUI":
                color = EUIColors[2];
                break;
            case "Poor EUI":
                color = EUIColors[3];
                break;
            case "Very Poor EUI":
                color = EUIColors[4];
                break;
            case "Extremely Poor EUI!":
                color = EUIColors[5];
                break;
            default:
                color = "black";
        }

        // variables that determine the EUI message
        let averageRange = maxGaugeRange / 2;
        let percentage = (Math.abs(averageRange - euiValue) / averageRange) * 100;
        let compareVerb = (euiValue < averageRange) ? "% below" : (euiValue > averageRange) ? "% above" : "";
        let percentageMessage = percentage.toFixed(1) + compareVerb; // do you want them rounded up or rounded down?

        // used for grammatical purposes
        let vowels = ['A', 'E', 'I', 'O', 'U'];
        // nested ternary operators to deal with null cases
        let article = (buildingType) ? vowels.includes(buildingType[0].toUpperCase()) ? "an" : "a" : "a";

        let message = euiValue < 0 ? <>This is {article} <b>{buildingType}</b> type of building</> : <>This EUI is <b style={{color: color}}>{percentageMessage}</b> the mean for <b>{buildingType}</b> buildings</>;

        const adjustedValue = (needleValue > -1) ? (needleValue / previousMaxRange) * maxGaugeRange : -1; // use ternary operator to trigger hide needle code
        // update building name
        setBuildingName(complexName);
        // update the numeric labels and data values (that represent the gauge range)
        setLabels(newLabels);
        setDataValues(newDataValues);

        // update the EUI building message
        setEUIMessage(message);

        // used to not update the gauge needle when the user clicks on a building with an Unknown EUI value
        reachedUnknown = quality === "Unknown EUI";
        // gauge value itself, not the needle value on the gauge
        if (!reachedUnknown)   {
            setTimeout(() => {
                setGaugeValue(euiValue);
            }, 100);
        }

        //console.log(gaugeValue);

        
        
        // update building's cooling loop
        setCoolingLoop(buildingGroup);

        //setBuildingsList(buildingsArr);

        //console.log(quality);
        //console.log(needleReachedNegative + " " + reachedUnknown);

        // animate the needle if the warning message isn't displaying
        if (!toastShown && !toastShown2)   {
            // animate from point A to point A if the user clicks on a building with an Unknown EUI value, otherwise animate from point A to point B
            animateNeedle(adjustedValue, (reachedUnknown) ? adjustedValue : euiValue);
        }

        // 🚀 Wait for animation to complete, THEN update `setNeedleValue`
        setTimeout(() => {
            //setNeedleValue(euiValue > maxGaugeRange ? maxGaugeRange : euiValue); // ✅ Now safely update the value AFTER animation ends
            setIsCooldown(false);  // ✅ Reset cooldown after the delay
            setToastShown(false);  // ✅ Explicitly reset toast state after cooldown ends
            //setTimeout(() => setPreviousBuildingName(""), 200);
        }, 2000);
    };

    // chart settings that customize its appearance
    const options = {
        rotation: -120,
        circumference: 240,
        cutout: '50%', // gauge thickness
        aspectRatio: 1,
        plugins: {
            legend: { display: false }, // Completely hide the legend
            tooltip: { enabled: false }
        },
        layout: {
            padding: 50
        },
        animation: {
            animateRotate: true,
            duration: 1000, // Animation duration in milliseconds
            easing: "easeOutCubic", // Smooth easing effect
        },
        responsive: true,
        maintainAspectRatio: false,
        // width: "300px",
        // height: "300px",
        
    };

    function determineColor() {
        let color = "";
        // setQuality(quality);
        switch (quality) {
            case "Excellent EUI":
                color = EUIColors[0];
                break;
            case "Good EUI":
                color = EUIColors[1];
                break;
            case "Average EUI":
                color = EUIColors[2];
                break;
            case "Poor EUI":
                color = EUIColors[3];
                break;
            case "Very Poor EUI":
                color = EUIColors[4];
                break;
            case "Extremely Poor EUI!":
                color = EUIColors[5];
                break;
            default:
                color = "black";
        }

        return color;
    }
 
    // useEffect(() => {
    //     if (gaugeRef.current) {
    //         gaugeRef.current.data = theData;
    //         gaugeRef.current.options = options;
    //         gaugeRef.current.update(); // Update chart instead of recreating
    //     }
    //     }, [theData, options]);

    // useEffect(() => {
    //     if (gaugeRef.current) {
    //         gaugeRef.current.data.datasets[0].data = dataValues;
    //         gaugeRef.current.update();
    //     }
    // }, [needleValue]);

   
    // registers components usable for the gauge chart
    ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, gaugeLabelsPlugin, gaugeNeedlePlugin);

    return ( 
        // <EUIContext.Provider value={gaugeValue}>
        <div className="GaugeFlex">
            {/* <br /> */}
            <div id="complexName">
                <h2 style={{textDecoration: "underline"}}>{buildingName}</h2>
            </div>
            <div id="coolingLoop">
               <h5>{(fiscalYear === 2023) ? (coolingLoop === "B" || coolingLoop === "") ? "" : (buildingName === "DEAN HALL") ? `Will use Cooling Loop ${coolingLoop}` : `Uses Cooling Loop ${coolingLoop}` : (coolingLoop === "") ? "" : (buildingName === "DEAN HALL") ? `Will use Cooling Loop ${coolingLoop}` : `Uses Cooling Loop ${coolingLoop}`}</h5> 
            </div>
            {/* <br />
            <br /> */}
            <div className="gauge-container">
                <Doughnut ref={gaugeRef} data={theData} options={options}  />
            </div>
            <h4>EUI Value:</h4>
            <h2>{(quality === "No EUI") ? "N/A" : (quality === "Unknown EUI") ? "???" : <><span style={{color: determineColor()}}>{gaugeValue}</span> <math xmlns="https://www.w3.org/1998/Math/MathML" className="fw-bold text"><mfrac><msup><mi>kWh/ft</mi><mn>2</mn></msup><mi>yr</mi></mfrac></math></>} </h2>
            {/* <br /> */}
            <h2 style={{color: determineColor()}}> {quality}</h2>
            {/* <br /> */}
            <p style={{maxWidth: "40vw", height: "84px", overflow: "hidden", fontSize: "20px"}}>{EUIMessage}</p>
            
            <ToastContainer />
        </div>
        /* // </EUIContext.Provider> */
        
    );
}

export default GaugeChart;